import axios from 'axios';

const createComment = ({ url, ...params }) => {
  return axios.post(url, params);
};

export { createComment };
